import { Box, Icon, Tooltip } from "@chakra-ui/react";
import { RiEyeOffLine } from "react-icons/ri";
import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { ColumnId } from "./constants";

type Row = { form: { isHiddenFromParent: boolean } };
export function buildVisibilityColumnDef<
  T extends Row
>(): ColumnDefWithTooltip<T> {
  return {
    accessorFn: (row) => row.form.isHiddenFromParent,
    id: ColumnId.Visibility,
    header: "",
    size: 20, // We can't precisely control the width of the column, so this will only "nudge" the column to use less space.
    cell: (props) =>
      props.row.original.form.isHiddenFromParent ? (
        <Tooltip label="Not visible to families" hasArrow placement="top">
          <Box>
            <Icon as={RiEyeOffLine} color="gray.500" boxSize="1.25rem" />
          </Box>
        </Tooltip>
      ) : null,
  };
}
